import type {
  MemoSectionKey,
  NextAction,
  ReviewStatus,
} from "@tex/finance-shared";

export const NEXT_ACTION_LABELS: Record<NextAction, string> = {
  start_review: "Start review",
  read_response: "Read response",
  write_memo: "Write memo",
  resolve_flags: "Resolve flags",
  awaiting_information: "Awaiting information",
  specialist_review: "Specialist review",
  ready_to_freeze: "Ready to freeze",
  frozen_awaiting_package: "Frozen — package next",
  not_proceeding: "Not proceeding",
};

export const REVIEW_STATUS_LABELS: Record<ReviewStatus, string> = {
  draft: "Draft",
  reviewed: "Reviewed",
  needs_information: "Needs information",
  specialist_review: "Specialist review",
  ready_to_package: "Ready to package",
  not_proceeding: "Not proceeding",
};

export const MEMO_SECTION_LABELS: Record<MemoSectionKey, string> = {
  request_and_purpose: "1. Request and purpose",
  business_profile: "2. Business profile",
  repayment_source: "3. Repayment source",
  existing_obligations: "4. Existing obligations",
  equipment_and_collateral: "5. Equipment and collateral",
  verification_and_fraud: "6. Verification and fraud checks",
  proposed_partner: "7. Proposed partner and program fit",
  conclusion: "8. Conclusion",
};
